<template>
  <div class="c-group">
    <filters
      v-if="mediaVal === 6"
      :states="states"
      :placeholder="`请输入${open}名称`"
      promoted
      agent
      @on-change="filterData"
      @on-search="searchFilterData"
    />
    <filters v-else :states="states" :placeholder="`请输入${open}名称`" @on-change="filterData" @on-search="searchFilterData"></filters>
    <Row class="c-control-btn">
      <Col span="8">
        <Button type="primary" @click="openNewEntry">新建{{ batch }}</Button>
        <Button type="primary" style="margin-left: 10px" v-if="showADAbtn" @click="openADAproject">新建ADA计划</Button>
        <Dropdown class="c-btn-group" @on-click="betch">
          <a href="javascript:void(0)">
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :name="1">启用</DropdownItem>
            <DropdownItem :name="2">暂停</DropdownItem>
            <DropdownItem :name="-1">删除</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button v-if="mediaVal === 16" @click="downData" class="c-btn-margin">数据导出</Button>
      </Col>
      <Col span="8" offset="8">
        <Button class="g-pull-right" @click="modalColumn = true">自定义列</Button>
        <div class="g-pull-right">
          <div class="c-account-balance">
            <span>账户余额：</span>
            <Icon v-if="balancing" type="ios-loading" size="18" class="c-account-load" color="#2b85e4"></Icon>
            <span v-else>{{ balance | toThousands }} 元</span>
          </div>
        </div>
      </Col>
    </Row>
    <!-- 表格列表 -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <group-table
          ref="groupTable"
          :value="spining"
          :data="groupList"
          :columns="tableCol"
          :media="mediaVal"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
          @header-dragend="headerDragend"
        ></group-table>
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <!-- 新建对话框 -->
    <open-modal v-model="modalOpen" :title="`新建${open}`" :media="mediaVal" @on-cancel="modalOpen = false"></open-modal>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from './mixin'
import { mapActions } from 'vuex'
import { getGroupList } from '@/api/convert.model'
import { HOST_API } from '@/api/config'
import { deepCopy, isArray } from '@/common/js/utils'
import Filters from '@/components/converter/filter.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import OpenModal from '@/components/converter/open-modal.vue'
import GroupTable from '@/components/converter/table/table-group.vue'

import { GROUP_TOUTIAO, GROUP_UC, GROUP_TENCENT, GROUP_BAIDU, GROUP_KUAISHOU } from '../data/tableTitle'

export default {
  name: 'GroupList',
  mixins: [mixin],
  components: { Filters, CustomColumn, OpenModal, GroupTable },
  computed: {
    mediaVal() {
      return parseInt(this.$route.params.id)
    },
    showADAbtn() {
      return this.mediaVal === 16
    },
    open() {
      let title
      if ([10].includes(this.mediaVal)) title = '计划组'
      else if ([16, 45, 32].includes(this.mediaVal)) title = '推广计划'
      else if ([6].includes(this.mediaVal)) title = '推广组'
      return title
    },
    batch() {
      let title
      if (this.mediaVal === 10) title = '投放计划'
      else if (this.mediaVal === 6) title = '推广计划'
      else if (this.mediaVal === 16) title = '普通计划'
      else if (this.mediaVal === 45) title = '推广单元'
      else if (this.mediaVal === 32) title = '计划组'
      return title
    },
    // 存local用户自定义列
    custom() {
      let custom
      if (this.mediaVal === 10) custom = 'group'
      else if (this.mediaVal === 6) custom = 'ucplan'
      else if (this.mediaVal === 16) custom = 'teplan'
      else if (this.mediaVal === 45) custom = 'bdplan'
      else if (this.mediaVal === 32) custom = 'ksplan'
      return custom
    },
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.groupTable && this.$refs.groupTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('Convert', ['handleAsync']),
    openADAproject() {
      window.open('/create/tencentada/project')
    },
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    getData(filter) {
      let params = {
        mediaId: this.mediaVal,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)

      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      // 请求数据
      this.spining = true
      getGroupList(
        Object.assign(params, {
          selectJson: JSON.stringify(params)
        })
      ).then((data) => {
        this.spining = false
        if (data && data.list && data.page_info) {
          // eslint-disable-next-line
          const { total_number } = data.page_info
          const fmt_tofix = (num) => parseFloat(num.toFixed(2))
          this.groupList = data.list.map((ret) => {
            const originStatus = deepCopy(ret.status)
            ret.status = this.mediaVal === 32 ? ret.originStatus === 1 : ret.status === 1
            ret.paperAmount = fmt_tofix(ret.paperAmount)
            ret.amount = fmt_tofix(ret.amount)
            ret.perClickPrice = fmt_tofix(ret.perClickPrice)
            ret.thousandsOfDisplayCosts = fmt_tofix(ret.thousandsOfDisplayCosts)
            ret.convertCost = fmt_tofix(ret.convertCost)
            ret.activeCost = fmt_tofix(ret.activeCost)
            ret.registerCost = fmt_tofix(ret.registerCost)
            ret.budgetFlag = parseInt(ret.budget) > 0 ? 1 : 0
            ret.day_budget_schedule = isArray(ret.day_budget_schedule) ? ret.day_budget_schedule : '不限'
            if (this.mediaVal === 32) ret.originStatus = originStatus > 0 ? originStatus - 1 : originStatus // 解决快手枚举不一致
            return ret
          })
          // eslint-disable-next-line
          this.total = total_number ? total_number : 0
          this.$nextTick(() => {
            this.$refs.groupTable && this.$refs.groupTable.doLayout()
          })
          this.handleAsync()
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    betch(type) {
      if ([1, 2, -1].includes(type)) {
        this.$refs.groupTable.changeBetch(type)
      }
    },
    downData() {
      let url = `${HOST_API}/api/ptom/adGroup/down`
      url += `?sessionid=${this.$store.state.token}&mediaId=${this.mediaVal}`
      url += `&queryBeginTime=${this.params.queryBeginTime}&queryEndTime=${this.params.queryEndTime}`
      this.params.adAccountId && (url += `&adAccountId=${this.params.adAccountId}`)
      this.params.status && (url += `&status=${this.params.status}`)
      this.params.keyWord && (url += `&keyWord=${this.params.keyWord}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    }
  },
  data() {
    return {
      tableHeight: 330,
      modalOpen: false, // 新建对话框
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      groupList: [], // 广告组列表
      columns: [],
      // 状态下拉数据
      states: [
        {
          value: -1,
          label: '不限'
        },
        {
          value: 1,
          label: '启用'
        },
        {
          value: 2,
          label: '暂停'
        }
      ]
    }
  },
  created() {
    let columns
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 表格列数据
    if (this.mediaVal === 10) columns = GROUP_TOUTIAO
    else if (this.mediaVal === 6) columns = GROUP_UC
    else if (this.mediaVal === 16) columns = GROUP_TENCENT
    else if (this.mediaVal === 45) columns = GROUP_BAIDU
    else if (this.mediaVal === 32) columns = GROUP_KUAISHOU
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
    // UC新闻增加状态
    const optStatus = [
      {
        value: 3,
        label: '推广预算不足'
      },
      {
        value: 4,
        label: '不在推广周期'
      }
    ]
    if (this.mediaVal === 6) this.states.push(...optStatus)
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  height: 100%;

  .c-control-btn {
    background-color: #fff;
    width: 100%;
    margin-bottom: 5px;

    .c-btn-group {
      padding-left: 15px;
      margin-left: 12px;
      line-height: 30px;
      height: 32px;
      border-radius: 3px;
      border: solid 1px #2d8cf0;
      width: 100px;
      display: inline-block;
      vertical-align: middle;
    }

    .c-btn-margin {
      margin-left: 12px !important;
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .c-account-balance {
    line-height: 32px;
    font-size: 14px;
    padding: 0 12px;
    margin-right: 8px;
    color: #ff0000;
  }

  .c-account-load {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
